import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, NgZone } from '@angular/core';
import { FormGroup, AbstractControl, FormBuilder, Validators, FormControl, ValidationErrors } from '@angular/forms';
import { Requisition } from '../../../../class/requisition';
import { SynergoRequisitionService } from '../../../../service/synergo-requisition/synergo-requisition.service';
import { TranslateService } from '@ngx-translate/core';
import { SelectItem, MultiSelectModule, AutoCompleteModule, CalendarModule } from 'primeng/primeng';
import { Router } from '@angular/router';
import { ProfileSurveyService } from '../../../../service/profile-survey/profile-survey.service';
import { CustomerGuide } from '../../../../class/customer-guide';
import { CustomerGuideService } from '../../../../service/customer-guide/customer-guide.service';
import { HasPermissionService } from '../../../../service/has-permission/has-permission.service';
import { NotificationsService } from '../../../../../../theme/services/notifications/notifications.service';

// import { Message, FileUpload } from 'primeng/primeng';
import { UploadFilesService } from '../../../../service/upload-files/upload-files.service';
import { config } from '../../../../../../../environments/config';
import { calendarES } from '../../../../../../theme/functions/calendarES';

@Component({
  selector: 'app-synergo-new-requisition',
  templateUrl: './synergo-new-requisition.component.html',
  styleUrls: ['./synergo-new-requisition.component.scss']
})

export class SynergoNewRequisitionComponent implements OnInit{
    @Output() msg: EventEmitter<object> = new EventEmitter<object>();
    @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Input() edit: Requisition;
    @Input() idCustomerGuide: string;
    public promiseForm: Promise<any>;
    public form: FormGroup;
    public created_at: AbstractControl;
    public venue_id: AbstractControl;
    public destination: AbstractControl;
    public estimated_time_requisition: AbstractControl;
    public company_id: AbstractControl;
    public count: AbstractControl;
    public count_additional: AbstractControl;
    public count_hired: AbstractControl;
    public time_elapsed: AbstractControl;
    public employee_id: AbstractControl;
    public status: AbstractControl;
    public type: AbstractControl;
    public selectedStatus: {label: string, value: string};
    public selectedType: {label: string, value: string};
    public closing_reason: AbstractControl;
    public selectedClosingReason: {label: string, value: string};
    public observation: AbstractControl;
    public justification: AbstractControl;
    public profile_survey_id: AbstractControl;
    public requested_at: AbstractControl;
    public wait_client: AbstractControl;
    public progress: AbstractControl;
    public myEmployeeId: string;

    public statusOptions: SelectItem[];
    public typeOptions: SelectItem[];
    public closing_reasonOptions: SelectItem[];

    public customer_guide_id: number;
    public employeePositionToLoad: string;
    public regional_claro: AbstractControl;
    public analyst_claro: AbstractControl;
    public referred_claro: AbstractControl;
    public customerGuides: CustomerGuide[];

    public requested_recruitment: AbstractControl;
    public quantity_recruitment: AbstractControl;
    public date_request_recruiment: AbstractControl;
    public employee_recruitment_id: AbstractControl;
    public requested_recruitment_var: Boolean =false;

    public loading_upload: boolean = false;
    public uploadedAttachment: any[] = [];
    public promiseAttachment: Promise<any>;
    public apiUrl = config.API_ROOT;
    public selectRequisition: Requisition;
    public uploadedFileSelection: any[] = [];
    // public msgs: Message[];

    public es: any;

    constructor(
        fb: FormBuilder,
        public synergoRequisitionService: SynergoRequisitionService,
        public uploadFilesService: UploadFilesService,
        public translate: TranslateService,
        public router: Router,
        public profileSurveyService: ProfileSurveyService,
        public customerGuideService: CustomerGuideService,
        public hasPermissionService: HasPermissionService,
        private notificationsService: NotificationsService,
        private ngZone: NgZone) {

        this.es = calendarES();

        this.customerGuides = [];

        this.employeePositionToLoad = '4,5,6,38';

        this.statusOptions = [
            {label: 'Abierto', value: 'Abierto'},
            {label: 'Congelado', value: 'Congelado'},
            {label: 'Cerrado', value: 'Cerrado'},
            //{label: 'Retirado', value: 'Retirado'},
            //{label: 'Backup', value: 'Backup'},
        ];

        this.typeOptions = [
            {label: 'Proceso de Selección', value: 'Proceso de Selección'},
            {label: 'Enviado por el cliente', value: 'Enviado por el cliente'},
            {label: 'Reingreso', value: 'Reingreso'},
        ];

        this.closing_reasonOptions = [
            {label: 'Baja Producción', value: 'Baja Producción'},
            {label: 'Ingreso De Requisición En Empresa Errada', value: 'Ingreso De Requisición En Empresa Errada'},
            {label: 'Convocatoria Interna Del Cliente', value: 'Convocatoria Interna Del Cliente'},
            {label: 'Retraso En El Cumplimiento De RH', value: 'Retraso En El Cumplimiento De RH'},
            {label: 'Falta De Toma De Decisión Del Cliente', value: 'Falta De Toma De Decisión Del Cliente'},
            {label: 'Cierre Sin Justa Causa', value: 'Cierre Sin Justa Causa'},
            {label: 'Repetición De La Requisición', value: 'Repetición De La Requisición'},
            {label: 'No Se Escribió El Número De Vacantes', value: 'No Se Escribió El Número De Vacantes'},
            {label: 'Cubrimiento De Otra Temporal', value: 'Cubrimiento De Otra Temporal'},
            {label: 'Error En Solicitud De Requisición', value: 'Error En Solicitud De Requisición'},
            {label: 'Cancelación Por El Cliente', value: 'Cancelación Por El Cliente'},
            {label: 'Congelada', value: 'Congelada'},
            {label: 'Error Solicitud Por Parte Del Cliente', value: 'Error Solicitud Por Parte Del Cliente'},
            {label: 'Contratación Directa Por Empresa Usuaria', value: 'Contratación Directa Por Empresa Usuaria'},
            {label: 'Requisición Por Otra Razon Social', value: 'Requisición Por Otra Razon Social'},
            {label: 'Error En Creación De Calidad', value: 'Error En Creación De Calidad'},
            {label: 'Solicitud Mayor A La Real', value: 'Solicitud Mayor A La Real'},
            {label: 'No Se Atendió Por Orden De Gerencia', value: 'No Se Atendió Por Orden De Gerencia'},
            {label: 'Se Contrató La Cantidad Solicitada', value: 'Se Contrató La Cantidad Solicitada'},
            {label: 'Modificación de Perfil', value: 'Modificación de Perfil'},
            {label: 'No Apto Ocupacional', value: 'No Apto Ocupacional'},
            {label: 'Candidato Desiste del Proceso', value:'Candidato Desiste del Proceso'}
        ];

        this.form = fb.group({
            'created_at': [{value: '', disabled: !this.hasPermission('edit requisition')}],
            'venue_id': [{value: '', disabled: !this.hasPermission('edit requisition')}],
            'destination': [{value: '', disabled: !this.hasPermission('edit requisition')}],
            'company_id': ['', Validators.compose([Validators.required, Validators.minLength(2)])],
            'count': [{value: 1, disabled: !this.hasPermission('edit requisition')}],
            'count_additional': [{value: 0, disabled: !this.hasPermission('edit requisition')}],
            'count_hired': [{value: 0, disabled: !this.hasPermission('edit requisition')}],
            'time_elapsed': [{value: '', disabled: !this.hasPermission('edit requisition')}],
            'employee_id': [''],
            'status': [{value: '', disabled: !this.hasPermission('edit requisition')}],
            'type': [{value: '', disabled: !this.hasPermission('edit requisition')}],
            'regional_claro':[''],
            'analyst_claro':[''],
            'referred_claro':[''],
            'closing_reason': [{value: '', disabled: !this.hasPermission('edit requisition')}],
            'observation': [{value: '', disabled: !this.hasPermission('edit requisition')}],
            'justification': [{value: '', disabled: !this.hasPermission('edit requisition')}],
            'profile_survey_id': [''],
            'requested_at': [''],

            'estimated_time_requisition': [''],
            'wait_client': [''],
            'progress': [''],
            'requested_recruitment':[''],
            'quantity_recruitment':['',Validators.compose([Validators.pattern("^[0-9]*$")])],
            'date_request_recruiment':[''],
            'employee_recruitment_id':[''],

        });

        if (this.hasPermission('get user company')) {
            this.form.get('destination').setValidators([Validators.required]);
            this.form.get('count').setValidators([Validators.required]);
            this.form.get('profile_survey_id').setValidators([Validators.required]);
        } else {
            this.form.get('venue_id').setValidators([Validators.required, Validators.minLength(1)]);
            this.form.get('destination').setValidators([Validators.required, Validators.minLength(2)]);
            this.form.get('count').setValidators([Validators.required]);
            this.form.get('count_additional').setValidators([Validators.required]);
            this.form.get('count_hired').setValidators([Validators.required, Validators.minLength(1)]);
            // this.form.get('employee_id').setValidators([Validators.required, Validators.minLength(1)]);
            this.form.get('status').setValidators([Validators.required, Validators.minLength(1)]);
            this.form.get('profile_survey_id').setValidators([Validators.required, Validators.minLength(2)]);
            this.form.get('requested_at').setValidators([Validators.required, Validators.minLength(2)]);
        }

        this.created_at = this.form.controls['created_at'];
        this.venue_id = this.form.controls['venue_id'];
        this.destination = this.form.controls['destination'];
        this.company_id = this.form.controls['company_id'];
        this.count = this.form.controls['count'];
        this.count_additional = this.form.controls['count_additional'];
        this.count_hired = this.form.controls['count_hired'];
        this.time_elapsed = this.form.controls['time_elapsed'];
        this.employee_id = this.form.controls['employee_id'];
        this.status = this.form.controls['status'];
        this.type = this.form.controls['type'];
        this.regional_claro= this.form.controls['regional_claro'];
        this.analyst_claro= this.form.controls['analyst_claro'];
        this.referred_claro = this.form.controls['referred_claro'];
        this.closing_reason = this.form.controls['closing_reason'];
        this.observation = this.form.controls['observation'];
        this.justification = this.form.controls['justification'];
        this.profile_survey_id = this.form.controls['profile_survey_id'];
        this.requested_at = this.form.controls['requested_at'];
        this.wait_client = this.form.controls['wait_client'];
        this.progress = this.form.controls['progress'];
        this.estimated_time_requisition = this.form.controls['estimated_time_requisition'];
        this.requested_recruitment= this.form.controls['requested_recruitment'];
        this.quantity_recruitment= this.form.controls['quantity_recruitment'];
        this.date_request_recruiment= this.form.controls['date_request_recruiment'];
        this.employee_recruitment_id= this.form.controls['employee_recruitment_id'];

    }

    ngOnInit() {
        this.myEmployeeId = JSON.parse(localStorage.getItem('profile')).employee_id;
        if (this.edit) {
            this.created_at.setValue(this.edit.created_at);
            this.venue_id.setValue(this.edit.venue_id);
            this.destination.setValue(this.edit.destination);
            this.company_id.setValue(this.edit.company_id);
            this.count.setValue(this.edit.count);
            this.count_additional.setValue(this.edit.count_additional);
            this.count_hired.setValue(this.edit.count_hired);
            this.estimated_time_requisition.setValue(this.edit.profile_survey.estimated_time_requisition);
            this.regional_claro.setValue(this.edit.regional_claro);
            this.analyst_claro.setValue(this.edit.analyst_claro);
            this.referred_claro.setValue(this.edit.referred_claro);
            if (this.edit.time_elapsed !== '') {
                const time_elapsed = new Date (this.edit.time_elapsed);
                const created_at = new Date (this.edit.created_at);
                this.time_elapsed.setValue(this.dateDiff(time_elapsed, created_at));
            } else {
                const today = new Date();
                const created_at = new Date (this.edit.created_at);
                this.time_elapsed.setValue(this.dateDiff(today, created_at));
            }

            this.employee_id.setValue(this.edit.employee);
            // this.status.setValue(this.edit.status);
            this.selectedStatus = {label: this.edit.status, value: this.edit.status};
            this.selectedType = {label: this.edit.type, value: this.edit.type};
            // this.closing_reason.setValue(this.edit.closing_reason);
            this.selectedClosingReason = {label: this.edit.closing_reason, value: this.edit.closing_reason};
            this.observation.setValue(this.edit.observation);
            this.justification.setValue(this.edit.justification);
            this.profile_survey_id.setValue(this.edit.profile_survey);
            this.requested_at.setValue(new Date(this.edit.requested_at));
            this.wait_client.setValue(this.edit.wait_client);
            this.idCustomerGuide = String(this.edit.customer_guide_id);
            this.profile_survey_id.setValue(this.edit.profile_survey);
            this.profile_survey_id.setValue(this.edit.profile_survey);
            this.profile_survey_id.setValue(this.edit.profile_survey);
            this.count_hired.disable();
            this.requested_recruitment_var=this.edit.requested_recruitment;// this.requested_recruitment.setValue(this.edit.requested_recruitment);
            this.quantity_recruitment.setValue(this.edit.quantity_recruitment);
            this.employee_recruitment_id.setValue(this.edit.employee_recruitment_id);
            // this.profile_survey_id.disable();
            if(this.edit.date_request_recruiment)
                this.date_request_recruiment.setValue(new Date(this.edit.date_request_recruiment + " UTC"));
            } else {
                this.count_hired.setValue('0');
                this.selectedType = {label: 'Proceso de Selección', value: 'Proceso de Selección'};
                this.selectedStatus = {label: null, value: null};
            }

        this.getCustomerGuides();
    }

    public cancelRequisition () {
        console.log('reset');
        this.form.reset();
        this.close.emit(true);
    }

    public newRequisition(values) {
        let param;
        var recruitment_status='';
        var recruitment_closing_date=null;
        if(this.edit){
            recruitment_status = this.edit.recruitment_status;
            recruitment_closing_date= this.edit.recruitment_closing_date;
            if(values.quantity_recruitment != this.edit.quantity_recruitment ||
                values.date_request_recruiment != this.edit.date_request_recruiment ||
                values.employee_recruitment_id != this.edit.employee_recruitment_id){
                if(this.edit.recruitment_closing_date != null){
                    recruitment_closing_date=null;
                    recruitment_status='Abierto';
                }
            }
        }
        else{
            (values.requested_recruitment == false) ? recruitment_status='No requerido' : recruitment_status='Abierto';
        }
        if (values.company_id.customer_guide) {
            if (this.hasPermission('get user company')) {
                param = {
                'destination': values.destination.name,
                'company_id': values.company_id.id,
                'customer_guide_id': values.company_id.customer_guide.id,
                'count': values.count,
                'count_additional': values.count_additional,
                'count_hired': values.count_hired,
                'profile_survey_id': values.profile_survey_id.id,
                'requested_at': this.formatDate(values.requested_at),
                'status': values.status.value,
                'type': values.type.value,
                }
            } else {
            param = {
                'venue_id': values.venue_id,
                'destination': values.destination.name,
                'company_id': values.company_id.id,
                'customer_guide_id': values.company_id.customer_guide.id,
                'count': values.count,
                'count_additional': values.count_additional,
                'count_hired': values.count_hired,
                'employee_id': values.employee_id.id,
                'status': values.status.value,
                'type': values.type.value,
                'closing_reason': values.closing_reason.value,
                'observation': values.observation,
                'justification': values.justification,
                'profile_survey_id': values.profile_survey_id.id,
                'requested_at': this.formatDate(values.requested_at),
                'wait_client': values.wait_client,
                'progress': values.progress,
                'regional_claro': values.regional_claro,
                'analyst_claro': values.analyst_claro,
                'referred_claro': values.referred_claro,
                'requested_recruitment': values.requested_recruitment,
                'quantity_recruitment': values.quantity_recruitment,
                'date_request_recruiment': (values.date_request_recruiment!='') ? values.date_request_recruiment:null,
                'employee_recruitment_id': (values.employee_recruitment_id !='' && values.employee_recruitment_id != null) ? values.employee_recruitment_id.id:null,
                'recruitment_status': recruitment_status,
                'recruitment_closing_date': recruitment_closing_date
                }
            };
        } else {
            if (this.hasPermission('get user company')) {
                param = {
                'destination': values.destination.name,
                'company_id': values.company_id.company.id,
                'customer_guide_id': values.company_id.id,
                'count': values.count,
                'count_additional': values.count_additional,
                'count_hired': values.count_hired,
                'profile_survey_id': values.profile_survey_id.id,
                'regional_claro': values.regional_claro,
                }
            } else {
                param = {
                'venue_id': values.venue_id,
                'destination': values.destination.name,
                'customer_guide_id': values.company_id.id,
                'company_id': values.company_id.company.id,
                'count': values.count,
                'count_additional': values.count_additional,
                'count_hired': values.count_hired,
                'employee_id': values.employee_id.id,
                'status': values.status.value,
                'type': values.type.value,
                'closing_reason': values.closing_reason.value,
                'observation': values.observation,
                'justification': values.justification,
                'profile_survey_id': values.profile_survey_id.id,
                'requested_at': this.formatDate(values.requested_at),
                'wait_client': values.wait_client,
                'progress': values.progress,
                'regional_claro': values.regional_claro,
                'analyst_claro': values.analyst_claro,
                'referred_claro': values.referred_claro,
                'requested_recruitment': values.requested_recruitment,
                'quantity_recruitment': values.quantity_recruitment,
                'date_request_recruiment': (values.date_request_recruiment!='') ? values.date_request_recruiment:null,
                'employee_recruitment_id': (values.employee_recruitment_id !='' && values.employee_recruitment_id != null) ? values.employee_recruitment_id.id:null,
                'recruitment_status': recruitment_status,
                'recruitment_closing_date': recruitment_closing_date
                };
            }
        }

        if (values && this.form.valid) {
            const promise = (this.edit) ?
                this.synergoRequisitionService.updateSynergoRequisition(this.edit.id, param)
                :
                this.synergoRequisitionService.newSynergoRequisition(param);

            this.promiseForm = promise.toPromise().then(
                response => {
                    this.translate.get('saved').subscribe((res: string) => {
                        this.notificationsService.growlNotify('success', res);
                        // this.msg.emit( { severity: 'success', summary: res  } );
                        this.close.emit(true);
                        this.form.reset();
                    });
                },
                error => {
                    let msg = '';
                    this.translate.get(JSON.parse(error._body).errors[0].detail).subscribe((res1: string) => {
                        this.translate.get(JSON.parse(error._body).errors[1].detail).subscribe((res2: string) => {
                            JSON.parse(error._body).errors.forEach(element => {
                                if (element.source) {
                                    if (element.source.pointer) {
                                        this.translate.get(element.source.pointer).subscribe((res3: string) => {
                                            msg = msg + res3 + ', ';
                                        });
                                    }
                                }
                            });
                            this.notificationsService.growlNotify('error', res1 + ' ' + res2 + ': ' + msg);
                            // this.msg.emit( { severity: 'error', summary: 'Error' } );
                        });
                    });
                }
            );
        }
    }

    public selectedCompany(values)
    {
        this.profile_survey_id.setValue('');
        if (values.customer_guide) {
            this.customer_guide_id = values.customer_guide.id;
        }
    }

    public dateDiff(date_future, date_now) {
        let seconds = Math.floor((date_future - (date_now)) / 1000);
        let minutes = Math.floor(seconds / 60);
        let hours = Math.floor(minutes / 60);

        const days = Math.floor(hours / 24);
        hours = hours - (days * 24);
        minutes = minutes - (days * 24 * 60) - (hours * 60);
        seconds = seconds - (days * 24 * 60 * 60) - (hours * 60 * 60) - (minutes * 60);

        return (days + ':' + hours + ':' + minutes + ':' + seconds);
    }

    public gotoProfileSurvey(values) {
      // this.router.navigate(['/pages/profile-survey'], { queryParams: { profile_survey: values.profile_survey_id } });
      window.open('/pages/profile-survey?profile_survey=' + values.profile_survey_id.id + '?token=' + localStorage.getItem('token'));
    }

    public gotoNewProfileSurvey(values) {
      // this.router.navigate(['/pages/profile-survey'], { queryParams: { profile_survey: values.profile_survey_id } });
      window.open('/pages/profile-survey?id_customer_guide=' + this.idCustomerGuide + '?token=' + localStorage.getItem('token'));
    }

    public getCustomerGuides() {
        const filters = [];
        if (this.idCustomerGuide) {
            filters.push({key: 'id-lk', value: String(this.idCustomerGuide)});
        }

        this.customerGuideService.getCustomerGuide(1, 1, undefined, undefined, filters).toPromise().then(
            response => {
                this.customerGuides = response.json().data;
                this.customer_guide_id = this.customerGuides[0].id;
                this.company_id.setValue(this.customerGuides[0]);
            },
            error => {
                // this.msgs = [];
                // this.msgs.push( { severity: 'error', summary: 'error' } );
            }
        );
    }

    public checkOtherValidation (values) {
        let check = false;
        if (values) {
          if (!this.hasPermission('get user company')) {
            if (values.type) {
              if (values.type.value === 'Proceso de Selección') {
                if (values.employee_id) {
                  if (values.employee_id.id) {
                      check = true;
                  } else {
                      return false;
                  }
                } else {
                  return false;
                }
              } else {
                check = true;
              }
            } else {
              return false;
            }
          }
          if (values.profile_survey_id) {
            if (values.profile_survey_id.id) {
                check = true;
            } else {
                return false;
            }
          }
        }
        return check;
    }

    public hasPermission(permission) {
        return this.hasPermissionService.hasPermission(permission);
    }

    getFormValidationErrors(form) {
        let value = '';
        Object.keys(form.controls).forEach(key => {
            const controlErrors: ValidationErrors = this.form.get(key).errors;
            if (controlErrors != null) {
                Object.keys(controlErrors).forEach(keyError => {
                    value = 'Key control: ' + key + ', keyError: ' + keyError + ', err value: ' + controlErrors[keyError];
                });
            }
        });
        return (value);
    }
    public hasRole(rol){
        var r: boolean=false;
        var role = JSON.parse(localStorage.getItem('profile')).roles[0].id;
        if(role == rol){
            r = true;
        }
        return (r);
    }

    public formatDate(date) {
        const d = new Date(date);
        let month = '' + (d.getMonth() + 1);
        let day = '' + d.getDate();
        const year = d.getFullYear();
        let hours = '' + d.getHours();
        let minutes = '' + d.getMinutes();
        let seconds = '' + d.getSeconds();

        if (month.length < 2) {
            month = '0' + month;
        }
        if (day.length < 2) {
            day = '0' + day;
        }

        if (hours.length < 2) {
            hours = '0' + hours;
        }

        if (minutes.length < 2) {
            minutes = '0' + minutes;
        }

        if (seconds.length < 2) {
            seconds = '0' + seconds;
        }

        return [year, month, day].join('-') + ' ' + [hours, minutes, seconds].join(':') +'.000';
    }

    public onUploadFileServiceOrder(event: any) {
        console.log(event);
    }

    public updateAttachmentServiceOrder(event, contract, checklist_profile_survey) {
        this.loading_upload = true;
        this.translate.get('uploading').subscribe((res: string) => {
            this.notificationsService.growlNotify('info', res + '...');
        });

          let id;
          if (checklist_profile_survey.document_profile_survey) {
            if (checklist_profile_survey.document_profile_survey.length > 0) {
              id = checklist_profile_survey.document_profile_survey[0].id;
            }
          }

          this.uploadedAttachment = [];
          for (const file of event.files) {
              this.uploadedAttachment.push(file);
          }

          this.promiseAttachment = this.uploadFilesService.updateAttachmentServiceOrder(this.uploadedAttachment, id).toPromise().then(
              response => {
                  this.translate.get('saved').subscribe((res: string) => {
                    this.notificationsService.growlNotify('success', res);
                  });

              },
              error => {
                this.loading_upload=false;
                  let msg = '';
                  this.translate.get(JSON.parse(error._body).errors[0].detail).subscribe((res1: string) => {
                      this.translate.get(JSON.parse(error._body).errors[1].detail).subscribe((res2: string) => {
                          JSON.parse(error._body).errors.forEach(element => {
                              if (element.source) {
                                  if (element.source.pointer) {
                                      this.translate.get(element.source.pointer).subscribe((res3: string) => {
                                          msg = msg + res3 + ', ';
                                      });
                                  }
                              }
                          });
                          this.notificationsService.growlNotify('error', res1 + ' ' + res2 + ': ' + msg);
                      });
                  });
              }
          );

    }

    public gotoAttachmentServiceOrder(id) {
      window.open(this.apiUrl + '/document-profile-surveis/' + id + '/attachment' + '?token=' + localStorage.getItem('token'), '_blank');
    }

    public deleteAttachmentServiceOrder(id) {
        this.promiseAttachment = this.uploadFilesService.deleteAttachmentServiceOrder(id).toPromise().then(
            response => {
                this.translate.get('saved').subscribe((res: string) => {
                    this.notificationsService.growlNotify('success', res);
                });
                delete this.uploadedAttachment[id];
            },
            error => {
                let msg = '';
                this.translate.get(JSON.parse(error._body).errors[0].detail).subscribe((res1: string) => {
                    this.translate.get(JSON.parse(error._body).errors[1].detail).subscribe((res2: string) => {
                        JSON.parse(error._body).errors.forEach(element => {
                            if (element.source) {
                                if (element.source.pointer) {
                                    this.translate.get(element.source.pointer).subscribe((res3: string) => {
                                        msg = msg + res3 + ', ';
                                    });
                                }
                            }
                        });
                        this.notificationsService.growlNotify('error', res1 + ' ' + res2 + ': ' + msg);
                    });
                });
            }
        );
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/synergo/synergo-requisitions/synergo-new-requisition/synergo-new-requisition.component.ts